/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymAppointmentsConfirmationAliases {
  CONTEXTUAL_BAR_APPOINTMENTS = 'contextual-bar-appointments',
  CONTEXTUAL_BAR_REQUEST = 'contextual-bar-request',
  CONTEXTUAL_BAR_WAITINGLIST = 'contextual-bar-waitinglist',
  FRAGMENT_REFERENCE_APPOINTMENT_DETAIL_APPOINTMENTS = 'fragment-reference-appointment-detail-appointments',
  FRAGMENT_REFERENCE_APPOINTMENT_DETAIL_REQUEST = 'fragment-reference-appointment-detail-request',
  FRAGMENT_REFERENCE_APPOINTMENT_DETAIL_WAITINGLIST = 'fragment-reference-appointment-detail-waitinglist',
  FRAGMENT_REFERENCE_PRINT_MODAL = 'fragment-reference-print-modal',
  LAYOUT_APPOINTMENT_DETAIL = 'layout-appointment-detail',
  LAYOUT_CONFIRMATION = 'layout-confirmation',
  LAYOUT_CONTENT = 'layout-content',
  PANEL_APPOINTMENTS = 'panel-appointments',
  PANEL_CONFIRMATION = 'panel-confirmation',
  PANEL_CONTEXTUALBAR_APPOINTMENTS = 'panel-contextualbar-appointments',
  PANEL_CONTEXTUALBAR_REQUEST = 'panel-contextualbar-request',
  PANEL_CONTEXTUALBAR_WAITINGLIST = 'panel-contextualbar-waitinglist',
  PANEL_MODAL = 'panel-modal',
  PANEL_SCHEDULES = 'panel-schedules',
  PANEL_WAITINGLIST = 'panel-waitinglist',
  ROUTE_PRINT = 'route-print',
}
export { PseudonymAppointmentsConfirmationAliases };
